module.exports = __webpack_public_path__ + "img/knue_gallery2.e0144390.jpg";